import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Loan } from '../models/loan.model';

@Injectable({
  providedIn: 'root'
})
export class SelectedLoanService {

  private loanKey: string = 'CURRENT_LOAN';

  private getSelectedLoan = new BehaviorSubject<Loan>(null);
  public selectedLoan$ = this.getSelectedLoan.asObservable();

  private getSelectedLoanId = new BehaviorSubject<string>(null);
  public selectedLoanId$ = this.getSelectedLoanId.asObservable();

  public setSelectedLoan(loan: Loan) {
    // console.log("Setting loan", loan);
    this.getSelectedLoan.next(loan);

    this.getSelectedLoanId.next(loan.loanNumber);
    sessionStorage.setItem(this.loanKey, JSON.stringify(loan));
  }

}